import React from 'react';
import { selectFileBlob } from '../../../store/selectors/modalWindow';

import { useAppSelector } from '../../../store';
import { useAppDispatch } from '../../../store';
import {
    selectFileId,
    selectFileMimeType,
    selectIsModalWindowOpen,
} from '../../../store/selectors/modalWindow';
import {
    closeModal,
    openModal,
} from '../../../store/actions/modalWindow/actionCreators';
import { CustomModalWindow } from './CustomModalWindow';
import { openFileInNextcloudThunk } from '../../../store/actions/app/thunks';
import { ImageContent } from './ImageContent';
import { VideoContent } from './VideoContent';
import { TextContent } from './TextContent';
import { PdfContent } from './PdfContent';
import { ContentType } from '../../../model';

export const FileModal = (): JSX.Element | null => {
    const isOpen = useAppSelector(selectIsModalWindowOpen);

    if (!isOpen) {
        return null;
    }

    return <FileModalProxy />;
};

export const FileModalProxy = (): JSX.Element | null => {
    const fileId = useAppSelector(selectFileId);
    const fileBlob = useAppSelector(selectFileBlob);
    const fileMimetype = useAppSelector(selectFileMimeType);
    const isOpen = useAppSelector(selectIsModalWindowOpen);

    const dispatch = useAppDispatch();

    const toggleModal = (): void => {
        if (isOpen) {
            dispatch(closeModal());
            return;
        }

        dispatch(openModal());
    };

    if (
        fileMimetype === ContentType.ImagePng ||
        fileMimetype === ContentType.ImageJpeg
    ) {
        return (
            <CustomModalWindow
                isOpen={isOpen}
                onClose={toggleModal}
                leftButtonText="Open in Nextcloud"
                onLeftButtonClick={() =>
                    dispatch(openFileInNextcloudThunk(fileId))
                }
            >
                <ImageContent fileBlob={fileBlob} />
            </CustomModalWindow>
        );
    }

    if (fileMimetype === ContentType.VideoMp4) {
        return (
            <CustomModalWindow
                isOpen={isOpen}
                onClose={toggleModal}
                leftButtonText="Open in Nextcloud"
                onLeftButtonClick={() =>
                    dispatch(openFileInNextcloudThunk(fileId))
                }
            >
                <VideoContent fileBlob={fileBlob} />
            </CustomModalWindow>
        );
    }

    if (
        [
            ContentType.TextMarkdown,
            ContentType.TextPlain,
            ContentType.ApplicationJson,
        ].includes(fileMimetype)
    ) {
        return (
            <CustomModalWindow
                isOpen={isOpen}
                onClose={toggleModal}
                leftButtonText="Open in Nextcloud"
                onLeftButtonClick={() =>
                    dispatch(openFileInNextcloudThunk(fileId))
                }
            >
                <TextContent fileBlob={fileBlob} />
            </CustomModalWindow>
        );
    }

    if (fileMimetype === ContentType.ApplicationPdf) {
        return (
            <CustomModalWindow
                isOpen={isOpen}
                onClose={toggleModal}
                leftButtonText="Open in Nextcloud"
                onLeftButtonClick={() =>
                    dispatch(openFileInNextcloudThunk(fileId))
                }
            >
                <PdfContent fileBlob={fileBlob} />
            </CustomModalWindow>
        );
    }

    return null;
};
